import { useEffect } from 'react';
import * as XLSX from 'xlsx'
import { formatDate } from './arrayUtils';

export const isString = (value) => { // CUP - 489 Added this method to check value is string or object
    if (typeof value === 'string') {
        return true;
    } else {
        return false;
    }
}

export const capitalizeWords = (str) => {
    if (!str) return '';
    return str.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  };

export const allCount=(count)=> {return Object?.values(count)?.reduce((acc, value) => acc + value, 0);}
export const checkAllFalse = (statusObj) => {return Object.values(statusObj).every(value => value === false);}
export const hasOneItsmServiceName = (customerMetaInfo) =>customerMetaInfo?.hasOwnProperty('oneITSMAccountServiceName') && customerMetaInfo?.oneITSMAccountServiceName?.trim() !== '' && customerMetaInfo.oneITSMAccountServiceName !== null && customerMetaInfo.oneITSMAccountServiceName !== undefined;


export function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (isLocked) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isLocked]);
}

export const handleDownload = (userDetails) => {
  const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : 'Not Available';
  const workbook = XLSX.utils.book_new();

  // Summary Sheet
  const customerSummaryLabels = {
    total_customers: 'Total number of onboarded customers',
    ipx_customers: 'Total number of IPX customers',
    signin_ipx_customers: 'Total number of signed in customer - IPX',
    ivc_customers: 'Total number of IVC customers',
    signin_ivc_customers: 'Total number of signed in customer - IVC'
  };

  const internalSummaryLabels = {
    all_users: 'All Users',
    signin_users: 'Signed-in Users',
    active_users: 'Active Users',
    inactive_users: 'Inactive Users'
  };

  const formatSummary = (summary, labels, excludeZeroKeys = []) =>
  Object.entries(summary || {})
    .filter(([key, value]) => !(excludeZeroKeys.includes(key) && value === 0))
    .map(([key, value]) => [labels[key] || key, value != null ? String(value) : 'Not Available']);

  const reportDate = new Date().toLocaleDateString('en-GB');

  const summaryData = [
    ['', 'IPXplore Onboarded Customer Report'],
    ['', ''],
    ['Date', reportDate],
    ...formatSummary(
      userDetails?.userDetails?.summary?.customers,
      customerSummaryLabels,
      ['ipx_customers', 'ivc_customers', 'signin_ipx_customers', 'signin_ivc_customers']
    ),
    ['', ''],
    ...(userDetails?.userDetails?.summary?.internal
      ? [['Summary - Internal User', ''],
         ...formatSummary(userDetails.userDetails.summary.internal, internalSummaryLabels)]
      : [])
  ];
  
const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');

  // IPX Customers Sheet
  const ipxCustomers = userDetails?.userDetails?.ipx_customer;
  if (Array.isArray(ipxCustomers) && ipxCustomers.length > 0) {
    const ipxData = [
      ['Organisation Legal Name', 'TADIG Code', 'User Name', 'User Email', 'Status', 'Approved On', 'Recent Activity Time'],
      ...ipxCustomers.map(user => [
        user.orgLegalName ?? 'Not Available',
        user.tadigCode ?? 'Not Available',
        user.displayName ?? 'Not Available',
        user.email ?? 'Not Available',
        capitalize(user.status),            
        user.createdAt ? formatDate(user.createdAt) : 'Not Available',
        user.currentLoginTime ? formatDate(user.currentLoginTime) : 'Not Available'
      ])
    ];
    const ipxSheet = XLSX.utils.aoa_to_sheet(ipxData);
    XLSX.utils.book_append_sheet(workbook, ipxSheet, 'IPX Customers and Primary User');
  }

// IVC Customers Sheet
const ivcCustomers = userDetails?.userDetails?.ivc_customer;
if (Array.isArray(ivcCustomers) && ivcCustomers.length > 0) {
  const ivcData = [
    ['Organisation Legal Name', 'User Name', 'User Email', 'Status', 'Approved On', 'Recent Activity Time'],
    ...ivcCustomers.map(user => [
      user.orgLegalName ?? 'Not Available',
      user.displayName ?? 'Not Available',
      user.email ?? 'Not Available',
      capitalize(user.status),                   
      user.createdAt ? formatDate(user.createdAt) : 'Not Available',
      user.currentLoginTime ? formatDate(user.currentLoginTime) : 'Not Available'
    ])
  ];
  const ivcSheet = XLSX.utils.aoa_to_sheet(ivcData);
  XLSX.utils.book_append_sheet(workbook, ivcSheet, 'IVC Customers and Primary User');
}

   // Vodafone Users Sheet
   const vfUsers = userDetails?.userDetails?.vf_users;
   if (Array.isArray(vfUsers) && vfUsers.length > 0) {
     const vfData = [
       ['User Email', 'User Name', 'Status', 'Persona', 'Created On', 'Recent Activity Time'],
       ...vfUsers.map(user => [
         user.email ?? 'Not Available',
         user.displayName ?? 'Not Available',
         capitalize(user.status),
         user.roleName ?? 'Not Available',
         user.createdAt ? formatDate(user.createdAt) : 'Not Available',
         user.currentLoginTime ? formatDate(user.currentLoginTime) : 'Not Available'
       ])
     ];
     const vfSheet = XLSX.utils.aoa_to_sheet(vfData);
     XLSX.utils.book_append_sheet(workbook, vfSheet, 'Vodafone Users');
   }

  // Customer Users Sheet
  // const customerUsers = userDetails?.userDetails?.customer_users;
  // if (Array.isArray(customerUsers) && customerUsers.length > 0) {
  //   const customerData = [
  //     ['Organisation Legal Name','User Name','User Email', 'Status', 'Service Type','Onboarded On', 'Recent Activity Time'],
  //     ...customerUsers.map(user => [
  //       user.orgLegalName ?? 'Not Available',
  //       user.displayName ?? 'Not Available',
  //       user.email ?? 'Not Available',
  //       capitalize(user.status),
  //       user.serviceType ?? 'Not Available',
  //       user.createdAt ? formatDate(user.createdAt) : 'Not Available',
  //       user.currentLoginTime ? formatDate(user.currentLoginTime) : 'Not Available'
  //     ])
  //   ];
  //   const customerSheet = XLSX.utils.aoa_to_sheet(customerData);
  //   XLSX.utils.book_append_sheet(workbook, customerSheet, 'Customer Users');
  // }

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download =`Onboarded_Customer_Report_${reportDate}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const getInitials = (name = "") => {
  const words = name.trim().split(" ")?.filter(Boolean);
  if (words?.length === 0) return "";
  const first = words[0][0];
  const last = words.length > 1 ? words[words.length - 1][0] : "";
  return (first + last).toUpperCase();
};

export const toTitleCase = str => str?.toLowerCase()?.replace(/\b\w/g, c => c?.toUpperCase());

export const renderTooltipList = (text) => {
    const items = text?.split("\n");

    const renderBold = (item) => {
        return item.split(/(\*\*.*?\*\*)/g).map((part, i) => {
            if (part.startsWith("**") && part.endsWith("**")) {
                return <strong key={i}>{part.slice(2, -2)}</strong>;
            }
            return part;
        });
    };

    return (
        <div style={{ fontFamily: "VodafoneRg-Regular" }}>
            {items.map((item, index) => {
                const isBullet = item.startsWith("- ");

                const cleanItem = isBullet ? item.slice(2) : item;

                return (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "start",
                            gap: "6px",
                            marginBottom: "4px"
                        }}
                    >
                        {isBullet && <span>•</span>}
                        <span>{renderBold(cleanItem)}</span>
                    </div>
                );
            })}
        </div>
    );
};
